import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Notification from "../../components/Common/Notification";
import ActivityLoader from "../../components/Common/ActivityLoader";
import ajaxUser from "../../util/remote/ajaxUser";
import functions from "../../util/functions";
import "../../index.css";
import LeftAd from "../../components/Welcome/LeftAd";

const LoginPage = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [info, setInfo] = useState("");
  const [showPwd, setShowPwd] = useState(false);

  const passwordInputType = useMemo(
    () => (showPwd ? "text" : "password"),
    [showPwd]
  );

  const onPressLogin = useCallback(
    async (event) => {
      event.preventDefault();

      if (username.length > 0 && password.length > 0) {
        setInfo(<ActivityLoader />);
        const server_response = await ajaxUser.login(username, password);

        if (server_response.status === "OK") {
          localStorage.setItem("ofc", server_response.details.token);

          const access_token = localStorage.getItem("ofc");
          const decoded_token = functions.parseJwt(access_token);
          const is_secure = decoded_token?.data?.is_secure;

          if (is_secure === "0" || is_secure === 0) {
            navigate("/password-reset", { replace: true });
            window.location.reload();
          } else {
            navigate("/", { replace: true });
            window.location.reload();
          }
        } else {
          setInfo(
            <Notification message={server_response?.message} type="danger" />
          );
        }
      } else {
        setInfo(
          <Notification message="Enter username and password" type="danger" />
        );
      }
    },
    [username, password, navigate]
  );

  const isLoggedIn = localStorage.getItem("ofc");
  if (isLoggedIn) return <Navigate to="/dashboard" />;

  return (
    <div className="ofLoginRoot">
      <div className="ofLoginBg" />

      <div className="ofLoginWrap">
        <div className="ofLoginGrid">
          {/* LEFT: Feature Carousel */}
          <LeftAd />

          {/* RIGHT: Login Form */}
          <div className="ofLoginRight">
            <div className="ofLoginCard">
              <div className="ofLoginHeader">
                <div className="ofLoginTitle">Welcome back</div>
                <div className="ofLoginSub">
                  Sign in to continue managing your WiFi business.
                </div>
              </div>

              {info}

              <form onSubmit={onPressLogin} className="ofForm">
                <div className="ofField">
                  <label htmlFor="username">Username</label>
                  <input
                    type="text"
                    id="username"
                    placeholder="Enter your email or username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                    autoComplete="username"
                  />
                </div>

                <div className="ofField">
                  <label htmlFor="password">Password</label>
                  <input
                    type={passwordInputType}
                    id="password"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    autoComplete="current-password"
                  />
                </div>

                <div className="ofRow">
                  <label className="ofCheck">
                    <input
                      type="checkbox"
                      checked={showPwd}
                      onChange={() => setShowPwd((s) => !s)}
                    />
                    <span>Show password</span>
                  </label>

                  <Link to="/forgot-password" className="ofLink">
                    Forgot password?
                  </Link>
                </div>

                <button className="ofBtn" type="submit">
                  Sign in
                </button>

                <div className="ofFooter">
                  <span>Don&apos;t have an account?</span>{" "}
                  <Link to="/signup" className="ofLinkStrong">
                    Sign up
                  </Link>
                </div>
              </form>
            </div>

            <div className="ofLegal">
              By signing in, you agree to our <span className="ofMuted">terms</span>{" "}
              and <span className="ofMuted">privacy policy</span>.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
